export const COLUMN_WIDTH = {
  DATE: 190,
  DRAG: 65,
} as const
